var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlatefrom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.875 20H30.75C29.3406 20 28.1875 21.125 28.1875 22.5V32.5C28.1875 33.875 29.3406 35 30.75 35H35.875C37.2844 35 38.4375 33.875 38.4375 32.5V22.5C38.4375 21.125 37.2844 20 35.875 20ZM34.5938 23.75C34.5938 24.4375 34.0172 25 33.3125 25C32.6078 25 32.0312 24.4375 32.0312 23.75V22.5H34.5938V23.75ZM33.3125 17.5V8.75C33.3125 6.6875 31.5828 5 29.4688 5H6.40625C4.29219 5 2.5625 6.6875 2.5625 8.75V22.5H25.625C25.625 19.7375 27.9184 17.5 30.75 17.5H33.3125ZM2.5625 26.25C2.5625 28.3125 4.29219 30 6.40625 30H13.2994L12.0181 32.5H11.5312C10.8266 32.5 10.25 33.0625 10.25 33.75C10.25 34.4375 10.8266 35 11.5312 35H24.3438C25.0484 35 25.625 34.4375 25.625 33.75C25.625 33.0625 25.0484 32.5 24.3438 32.5H23.8697L22.6269 30H25.625V25H2.5625V26.25Z",
    fill: "url(#paint0_linear_448_323)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_448_323",
    x1: 20.5,
    y1: 5,
    x2: 20.5,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B41E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0FB6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatefrom);
export default __webpack_public_path__ + "static/media/platefrom.991fb2b70e26083eb06e05b69e3b14cd.svg";
export { ForwardRef as ReactComponent };